import React from "react";
import PropTypes from "prop-types";

function InstallmentActionButton(props) {
  const { text, onClick, icon } = props;
  return (
    <div className="installment-card-content-action" onClick={onClick}>
      <div className="installment-card-content-action-icon">
        {icon}
      </div>
      <div className="installment-card-content-action-text">
        <span>{text}</span>
      </div>
    </div>
  );
}

InstallmentActionButton.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.node,
};

export { InstallmentActionButton };
